import { Col, Row } from "antd";
import { HTMLAttributes } from "react";
import { cssGrayscale } from "utils/utils";
import styles from "../Interactive.module.scss";

export const Titled = ({
  title,
  children,
  style,
  contrastGrayscale,
  ...rest
}: {
  title?: string;
  contrastGrayscale?: number;
} & HTMLAttributes<HTMLDivElement>) => (
  <div style={{ flex: 1, ...style }} {...rest}>
    {title && (
      <Row
        justify="end"
        style={{ color: cssGrayscale(contrastGrayscale), marginBottom: 16 }}
      >
        <Col flex={0} className={styles.title}>
          {title}
        </Col>
      </Row>
    )}
    {children}
  </div>
);
